export const API_BASE = process.env.EMPLOYMENT_TIME_API;
export const CLIENT_SETUP_API_PATH = 'client-setup';
